import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';

import { CypressTagDirective } from '@cjm/cypress/core';
import { VLoketAppRoutePaths } from '@cjm/shared/route-paths';
import { ButtonClasses, LayoutContainerComponent, LinkComponent } from '@cjm/shared/ui/common';

import { I18nKeys } from '../../../i18n';

@Component({
	selector: 'vloket-about-us-section',
	templateUrl: 'about-us-section.component.html',
	styleUrls: ['about-us-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [LayoutContainerComponent, LinkComponent, TranslateModule, CypressTagDirective]
})
export class AboutUsSectionComponent {
	@HostBinding('class.c-about-us-section') private readonly hasPageClass: boolean = true;

	public readonly buttonClasses: typeof ButtonClasses = ButtonClasses;
	public readonly i18nKeys: typeof I18nKeys = I18nKeys;
	public readonly appRoutePaths: typeof VLoketAppRoutePaths = VLoketAppRoutePaths;
	public readonly cards: { cardTitle: string; cardDescription: string }[] = [
		{
			cardTitle: this.i18nService.getTranslation(
				this.i18nKeys.Home.AboutUsSection.Cards.LinkYourServicesAndInformation.CardTitle
			),
			cardDescription: this.i18nService.getTranslation(
				this.i18nKeys.Home.AboutUsSection.Cards.LinkYourServicesAndInformation.CardDescription
			)
		},
		{
			cardTitle: this.i18nService.getTranslation(
				this.i18nKeys.Home.AboutUsSection.Cards.WorkAlongInformation.CardTitle
			),
			cardDescription: this.i18nService.getTranslation(
				this.i18nKeys.Home.AboutUsSection.Cards.WorkAlongInformation.CardDescription
			)
		}
	];

	constructor(public i18nService: NgxI18nService) {}
}
